import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import { currencies } from '@piconetworks/pkg-currency';
import FormInput from '../FormInput/index.js';

var _excluded = ["currencyCode", "symbol", "suffix", "formatType", "inputFormat", "inputPrefix", "prefix"];
var FormFormatInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var currencyCode = _ref.currencyCode,
    symbol = _ref.symbol,
    suffix = _ref.suffix,
    formatType = _ref.formatType,
    inputFormat = _ref.inputFormat,
    inputPrefix = _ref.inputPrefix;
    _ref.prefix;
    var props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var currency = currencies[currencyCode] || 'USD';
  var formatTypes = {
    currency: {
      thousandSeparator: ',',
      prefix: symbol ? currency.symbol_native : '',
      suffix: suffix,
      decimalScale: currency.decimal_digits || 0,
      fixedDecimalScale: true,
      allowNegative: false
    }
  };
  return /*#__PURE__*/React.createElement(NumberFormat, _extends({
    getInputRef: ref,
    customInput: FormInput,
    autoComplete: "off",
    label: "Pricing Input",
    onBlur: props.input.onBlur,
    onFocus: props.input.onFocus,
    value: props.input.value,
    onChange: function onChange(value) {
      props.input.onChange(value);
    },
    onValueChange: function onValueChange(_ref2) {
      var formattedValue = _ref2.formattedValue;
      props.input.onChange(formattedValue);
    },
    format: inputFormat
  }, formatTypes[formatType], props, {
    prefixValue: inputPrefix
  }));
});
FormFormatInput.displayName = 'FormFormatInput';
FormFormatInput.propTypes = {
  currencyCode: PropTypes.string,
  formatType: PropTypes.string,
  prefix: PropTypes.bool,
  input: PropTypes.object,
  inputPrefix: PropTypes.string,
  inputFormat: PropTypes.string,
  suffix: PropTypes.string,
  symbol: PropTypes.bool
};
FormFormatInput.defaultProps = {
  currencyCode: 'USD',
  formatType: 'currency',
  symbol: false
};

export { FormFormatInput as default };
//# sourceMappingURL=index.js.map
